(function () {
	'use strict';

	String.prototype.rot13 = function () {
		return this.replace(/[a-zA-Z]/g, function (c) {
			return String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
		});
	};

	let i;
	let	emls = document.getElementsByClassName('eml-obs');

	for (i = 0; i < emls.length; i += 1) {
		let eml = emls[i];
		const obfuscatedEmail = eml.getAttribute('data-eml');

		if (!obfuscatedEmail) {
			continue;
		}

		let deobfuscatedEmail = obfuscatedEmail.rot13().split('').reverse().join('').replace(':', '@');

		eml.href = 'mailto:' + deobfuscatedEmail;
		eml.removeAttribute('data-eml');

		if (!eml.textContent) {
			eml.textContent = deobfuscatedEmail;
		}
	}
})();
